enum ICC_PRODUCT_STATUS_TYPES {
    FAILED = 'Failed',
    REGISTERED = 'Registered',
    REGISTERING = 'Registering',
    UNREGISTERED = 'Unregistered',
    UNREGISTERING = 'Unregistering',
}

export default ICC_PRODUCT_STATUS_TYPES;
